module.exports = __webpack_public_path__ + "img/product09-tongyi.37e03ca3.svg";